export default "__VITE_ASSET__BYcEOdk1__"